import { IntegrationAdapter, IntegrationConnectorId } from "./contracts";
import { aiClient } from "../intelligence/providers";
import { syncGoogleWorkspaceSignals } from "./googleWorkspace";

/**
 * Gmail Integration Adapter 🛰️
 *
 * Role: Listens for recruiter signals and job-related threads.
 * Pipeline: Search -> Fetch Snippets -> AI Signal Extraction -> Core Draft
 */
export class GmailAdapter implements IntegrationAdapter {
  id: IntegrationConnectorId = "gmail";

  /**
   * Pulls relevant email snippets based on an opportunity or global context.
   */
  async pullSignals(opportunityId: string): Promise<string[]> {
    console.log(`[Gmail] Pulling signals for play: ${opportunityId}`);
    const result = await syncGoogleWorkspaceSignals(this.id, opportunityId, 20);
    return result.signals;
  }

  /**
   * High-fidelity ingest that turns a found email into a structured signal.
   */
  async ingestEmail(rawText: string) {
    const structured = await aiClient.extractStructuredSignal(rawText);
    return structured;
  }
}

export const gmailAdapter = new GmailAdapter();
